/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import PatchManager from "App/utils/globe/chunk_lod/patch_manager";
import Visitor, {VisitorOrdering} from "App/utils/globe/chunk_lod/visitor";
import TreeNode from "App/utils/globe/chunk_lod/tree/node";

export default
class DebugManager extends Visitor {
    private _patchManager: PatchManager;
    private _debugData: { values: { visibilityState: Uint8Array; nodeState: Uint8Array; treeStructure: Uint8Array } };
    private _needUpdate: boolean;

    constructor(aPatchManager: PatchManager) {
        super();

        this._patchManager = aPatchManager;

        this._visiteeConsumerFunction = this.collectDebugData.bind(this);
        this._ordering = VisitorOrdering.pre;

        this._debugData = {
            values: {
                nodeState: null,
                treeStructure: null,
                visibilityState: null
            }
        };

        this._needUpdate = true;
    }

    public clearData() {
        let patchInfo = this._patchManager.getPatchInfo();
        let byteSize = TreeNode.getFlattenedTreeSize(patchInfo.levels, patchInfo.nc);
        this._debugData.values.nodeState = new Uint8Array(byteSize);
        this._debugData.values.treeStructure = new Uint8Array(byteSize);
        this._debugData.values.visibilityState = new Uint8Array(byteSize);
    }

    public collectDebugData(aVisitee: TreeNode) {
        let address = aVisitee.getAddress();
        // look at children and if they are settled on gpu, then do not render this node
        this._debugData.values.nodeState[TreeNode.getIndexToFlattenedTree(address)] = aVisitee.getState();
        this._debugData.values.treeStructure[TreeNode.getIndexToFlattenedTree(address)] = 1;
        this._debugData.values.visibilityState[TreeNode.getIndexToFlattenedTree(address)] = this._patchManager.getVisibilityManager().getVisibility(aVisitee);
    }

    public update() {
        let worker = this._patchManager.getWorker();

        // send visibility vector to main thread and use the vector to decide what nodes will be rendered and what does not
        let message = {
            type: "debugDataUpdate",
            patchInfo: this._patchManager.getPatchInfo(),
            data: this._debugData
        };

        this._needUpdate = false;

        worker.schedulePostMessage(message);
    }
}
